export const apiGetWarehouseIn = "/1.0/wsm/warehouse/listPropose"
// export const apiWarehouseInDetail= `/1.0/wsm/warehouse/${id}/detail`
export const apiCreateSimSuggested = "/1.0/wsm/warehouse/create"
export const apiExportSimSuggested = "/1.0/wsm/warehouse/export/listsim"


export const apiListProvider = "1.0/wsm/supplier/list"
export const apiListCarrier = "1.0/wsm/network/listall"
export const apiExportExcelTemplate = "/1.0/wsm/warehouse/export"
export const apiImportExcelTemplate = "/1.0/wsm/warehouse/import"


export const apiListData = "/1.0/wsm/data/list"
export const apiCreateData = "/1.0/wsm/data/create"
export const apiDeleteData = "/1.0/wsm/data/delete"

export const apiCreateOrder = "/1.0/wsm/history/warehouse/create"
export const apiListWarehouseOrder = "/1.0/wsm/history/warehouse/list"

export const apiGetStock = "/1.0/wsm/history/warehouse/list/sim"

export const apiSimWarehouse = "/1.0/wsm/warehouse/list"

export const apiSimSuggestedDetail = "/1.0/wsm/warehouse/listsim"

export const apiUpdateSimSuggested = id => `1.0/wsm/warehouse/${id}/updatedetailsim`

export const apiDetailOrder = id => `/1.0/wsm/history/warehouse/${id}/detail`

export const apiExportWarehouse = "/1.0/wsm/export/warehouse/list"
export const apiUpdateOrder = id => `/1.0/wsm/history/warehouse/${id}/update`

export const apiExportData = "/1.0/wsm/warehouse/exportdata"

export const apiExportWareHouseData = "/1.0/wsm/data/export"
export const apiExportWareHouseAppovalData = "/1.0/wsm/data/export/approval"

export const apiExportOutOfStock = "/1.0/wsm/export/warehouse/export"
export const apiExportWareHouseDataLeader = "/1.0/wsm/leader/order/list/data"
// deliverybill
export const apiUpdateExportWarehouse = (id) => `/1.0/wsm/export/warehouse/${id}/update`
export const apiGetWarehouseWarning = "/1.0/wsm/warehouse/warning"
export const apiDeleteWarehouse = "/1.0/wsm/warehouse/delete"

export const apiGetHistoryUpdateSim = (id) => `1.0/wsm/warehouse/${id}/detail/sim/update`
